var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmeraldRinginline = function SvgEmeraldRinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    clipPath: "url(#EmeraldRing_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.138 3.866v12.602l2.468 2.923h8.055L14 16.533V3.866l-2.144-2.728H3.541z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.006 6.72v6.982l1.367 1.62h4.463l1.296-1.584V6.72L9.944 5.208H5.337zM3.541 1.138l1.796 4.07M11.856 1.138l-1.912 4.07M11.132 6.72 14 3.866M11.132 13.738 14 16.533M9.836 15.321l1.825 4.07M5.373 15.321l-1.767 4.07M4.006 13.702l-2.868 2.766M4.006 6.72 1.138 3.866"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "EmeraldRing_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15v20H0z"
  })))));
};
export default SvgEmeraldRinginline;